import React from 'react';
import { Banner as BannerVoucher } from '@lux/banner';
export const VoucherBanner = ({ event, onClose, onRedeem }) => {
    return (React.createElement(BannerVoucher, { title: event.title, 
        // eslint-disable-next-line react/no-danger
        text: React.createElement("span", { dangerouslySetInnerHTML: { __html: event.content } }), footNote: event.disclaimer, linkText: event.ctaText, onCloseBanner: onClose, onLinkClick: onRedeem }));
};
//# sourceMappingURL=component.js.map